module.exports = __webpack_public_path__ + "img/category-brand.948b36c2.png";